import React from 'react';
import './Taxi.css';

import { FaGasPump, FaSuitcaseRolling, FaDollarSign } from 'react-icons/fa';
import { FaUserGroup } from "react-icons/fa6";

import { Link } from 'react-router-dom';
import Button from '../Button/Button';



const Taxi = ({ taxi }) => {

  return ( 
    <div className="taxi-item">

      <div className='image'>
        <img src={taxi.image} alt={taxi.name} />
        <div className='price'>{taxi.baseFare}<span>/base fare</span></div>
      </div>

      <div className="content">

        {/* Car name with link to car details page */}
        <Link to={{
            pathname: '/Taxis/' + taxi.name,
          }}
          state={taxi}>
          <h2>{taxi.name}</h2>
        </Link>

        <p>{taxi.vehicleList.slice(0, 2).join(", ")}, or similar.</p>

        {/* Car specifications */}
        <div className="details">
          <h3><FaUserGroup className="icon" /><span>{taxi.details.passengers}</span></h3>
          <h3><FaSuitcaseRolling className="icon" /><span>{taxi.details.luggages}</span></h3>
          <h3><FaGasPump className="icon" /><span>{taxi.details.fuelType}</span></h3>
          <h3><FaDollarSign className="icon" /><span>{taxi.details.costPerMile}</span></h3>
        </div>

        <Button link={'Booking'} title={'Book Now'} />

      </div>
    </div>
  );
};

export default Taxi;